
import { Component, Vue } from 'vue-property-decorator'
import i18n from '@/i18n'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'

enum MotorCockpitEnum {
  Default,
  Fahrleistung,
  Versicherungsumfang,
  Fahrerkreis
}

@Component({
  i18n,
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.MOTOR).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.MOTOR).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  }
})
export default class ChangeMotorCockpitPage extends Vue {
  private changeType = ''

  private partnerProxyId: string | null = null

  public mounted(): void {
    for (const item in MotorCockpitEnum) {
      if (
        window.location.pathname.includes(
          `${window.ENV_CONFIG.SERVICE_LINKS.VERTRAGSSERVICES_PAGE.ROOT}/motor-cockpit-${item.toLowerCase()}`
        )
      ) {
        this.changeType = 'Change' + item[0].toUpperCase() + item.slice(1)
      }
    }
  }

  public created(): void {
    this.partnerProxyId = getPartnerProxyId()
  }
}
